<template>
  <Fragment>
    <VNavigationDrawer
      :class="['main-menu', {'custom-theme': isCustomTheme}]"
      app
      clipped
      floating
      width="100"
    >
      <VBtn
        v-if="account.profile.is_default_listener && !vendor.branding?.hide_default_listener_orders_link"
        @click="dialog=true"
      >
        <VIcon>$uchi_orders</VIcon>
        {{ $t('$sdo.lc_menu_order_management.one') }}
      </VBtn>

      <template v-if="menuItems && menuItems.length">
        <VBtn
          v-for="menuItem in menuItems"
          :key="menuItem.name"
          :to="menuItem.to"
          :href="menuItem.href"
        >
          <VBadge
            :value="menuItem.counter"
            :content="menuItem.counter"
            overlap
          >
            <VIcon>{{ menuItem.icon }}</VIcon>
          </VBadge>
          {{ $t(menuItem.title) }}
        </VBtn>
      </template>
    </VNavigationDrawer>
    <VDialog
      v-if="!isGuest"
      v-model="dialog"
      max-width="400"
    >
      <VCard>
        <VForm
          method="POST"
          :action="'/users/'+ account.parent_id + '/login'"
          autocomplete="off"
        >
          <VCardTitle>
            {{ $t('$app.go_management') }}
          </VCardTitle>
          <VDivider />
          <VCardActions>
            <VSpacer />
            <VBtn
              color="primary"
              text
              @click="dialog = false"
            >
              {{ $t('no.one') }}
            </VBtn>
            <VBtn
              color="error"
              type="submit"
            >
              {{ $t('yes.one') }}
            </VBtn>
          </VCardActions>
        </VForm>
      </VCard>
    </VDialog>
  </Fragment>
</template>

<script>
import { mapGetters } from 'vuex'

import { Fragment } from 'vue-fragment'
import * as getters from '@/store/getters/types'
import { GUEST, isGuest } from '@/utils/role'

export default {
  name: 'AppMenu',

  components: {
    Fragment,
  },

  props: {
    menuItems: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return {
      dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      account: getters.ACCOUNT,
      vendor: getters.VENDOR,
    }),

    isGuest () {
      return isGuest(this.account?.role?.code || GUEST)
    }
  },

  methods: {
    isCustomTheme () {
      return this.vendor?.branding?.theme === 'custom' || this.vendor?.branding?.listener_cabinet_theme === 'custom'
    },
  }
}
</script>

<style lang="scss">
.v-application {
  .main-menu {
    background-image: linear-gradient(to bottom, var(--v-background-lighten2), var(--v-background-base));

    .v-btn.v-size--default {
      height: auto;
      color: var(--v-text-base);
      background-color: transparent !important;
      display: block;
      width: 100%;
      min-width: 100%;
      box-shadow: none;
      white-space: normal;
      text-align: center;
      padding: ($spacer * 4) $spacer;
      text-transform: none;
      letter-spacing: normal;
    }

    .v-btn__content {
      flex-direction: column;
    }

    .v-icon,
    .v-icon__svg {
      font-size: 32px;
      width: 32px;
      height: 32px;
    }
  }

  .main-menu.custom-theme {
    background-image: linear-gradient(to bottom, var(--nav-background-up-color), var(--nav-background-down-color));
  }
}
</style>
